import { Serializable } from './Serializable';

export class User extends Serializable {
  userId: number;
  emailAddress: string;
  enabled: boolean;
  nickName: string;
  preferredLanguage: string;
  managerType: string;
  acceptTnC: boolean;
  firstName: string;
  lastName: string;
  preferredUnit: string;
  isSSOFederated: boolean;
  displayName: string;
  zendeskToken: string;
  tokenExpiryAt: string;
  profileImageUrl: string;
  isSubscriptionAccepted: boolean;
  resetPassword: boolean;
  hasNewPasswordPolicy: string;
  isASBU: boolean;

  constructor(json?: any) {
    super(json);
    this.userId = json.userId;
    this.emailAddress = json.emailAddress;
    if (json.userImage != null) {
      this.profileImageUrl = json.userImage.thumbnailUrl;
    }
    /*if(this.acceptTnC==null)        
            this.acceptTnC=false;*/
    if (json.acceptTnC === 'true') this.acceptTnC = true;
    else this.acceptTnC = false;
    if (json.resetPassword === 'true') this.resetPassword = true;
    else this.resetPassword = false;
    if (json.isSSOFederated === 'true') this.isSSOFederated = true;
    else this.isSSOFederated = false;

    if (json.isASBU === 'true') this.isASBU = true;
    else this.isASBU = false;

    this.preferredLanguage = json.preferredLanguage;
  }
}
